"use strict";
import Swiper from 'swiper/bundle';

let swipeOption = {
  autoplay: {
    delay: 5000,
  },
  loop: true,
  slidesPerView: "auto",
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev'
  },
}

let swiper =  new Swiper('.swiper-container', swipeOption);


document.querySelector(".swiper-container").addEventListener(
  "mouseenter",
  () => {
    swiper.autoplay.stop();
  },
  false
);

document.querySelector(".swiper-container").addEventListener(
  "mouseleave",
  () => {
    swiper.autoplay.start();
  },
  false
);